import { ActivatedRoute, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { EnvironmentInjector, inject, Injector } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { modalFn } from '@softline/ui-core';
import { TerminalInitService } from '../modules/main/services/terminal-init.service';
import { SOFTLINE_CONFIG_WWS_CASH_REGISTER_PARAMS } from '../pos.shared';
import {
  TERMINAL_MODAL_INIT,
  TERMINAL_MODAL_SSE_KEY,
  TerminalModalComponent,
} from '../modules/main/modals/terminal-modal/terminal-modal.component';
import { handleRequestError } from '@softline/application';
import { map } from 'rxjs';

export const posConfigurationResolver: ResolveFn<any> = async (route) => {
  const service = inject(ApiDataAccess);
  const modal = modalFn();
  const router = inject(Router);
  const injector = inject(Injector);
  const environmentInjector = inject(EnvironmentInjector);
  const activatedRoute = inject(ActivatedRoute);
  const terminalService = inject(TerminalInitService);
  const posConfig = inject(SOFTLINE_CONFIG_WWS_CASH_REGISTER_PARAMS);

  const config = await service.get<{ terminalSseKey?: string }>({
    path: '/pointofsale-service/point-of-sale/configuration',
  });

  if (posConfig?.hasTerminal !== undefined && posConfig?.hasTerminal === false) {
    return config;
  } else if (route.queryParamMap.has('terminalInit')) {
    await modal({
      title: 'Bankomat initialisieren',
      subtitle: 'Verbindung zum Bankomat-Terminal wird hergestellt.',
      icon: 'fa-regular fa-credit-card',
      dismiss: false,
      component: TerminalModalComponent,
      injector: Injector.create({
        parent: environmentInjector,
        providers: [
          {
            provide: TERMINAL_MODAL_INIT,
            useValue: async (resolveFn) => {
              try {
                await terminalService.init();
                setTimeout(() => {
                  resolveFn(true);
                }, 900);
              } catch (e) {
                handleRequestError(e, injector, { show: true });
                terminalService.state.set('ERROR');
                console.error(e);
                resolveFn(false);
              }
            },
          },
          {
            provide: ActivatedRoute,
            useValue: {
              ...activatedRoute,
              data: activatedRoute.data.pipe(
                map((data) => ({
                  ...data,
                  configuration: config,
                }))
              ),
            },
          },
          {
            provide: TERMINAL_MODAL_SSE_KEY,
            useValue: config?.terminalSseKey,
          },
        ],
      }),
      data: {
        finalizeRequired: false,
      },
    });

    return config;
  } else if (!terminalService.initialized()) {
    const urlTree = router.createUrlTree(['/pos'], {
      queryParams: {
        terminalInit: true,
      },
    });

    return new RedirectCommand(urlTree);
  }

  return config;
};
